var map = {
	"./posts.markdown/Post10Lainnovaciondigital.md": [
		8987,
		1,
		987
	],
	"./posts.markdown/Post11Transformaciondigitalempresarial.md": [
		986,
		1,
		986
	],
	"./posts.markdown/Post12Transformaciondigital.md": [
		1104,
		1,
		104
	],
	"./posts.markdown/Post1LatransformaciondigitalenPymesPeruanas.md": [
		7538,
		1,
		538
	],
	"./posts.markdown/Post2Losproyectostecnologicosquemarcaranel2023.md": [
		6414,
		1,
		414
	],
	"./posts.markdown/Post3Losdatosdecalidad.md": [
		4630,
		1,
		630
	],
	"./posts.markdown/Post4Siliconvalleybank.md": [
		7893,
		1,
		893
	],
	"./posts.markdown/Post5Laimportanciadelasfinanzas.md": [
		4942,
		1,
		942
	],
	"./posts.markdown/Post6Pronosticoseconomicospara2023.md": [
		1771,
		1,
		771
	],
	"./posts.markdown/Post7Recursoshumanos4.0.md": [
		1418,
		1,
		418
	],
	"./posts.markdown/Post8Losretospararecursoshumanosen2023.md": [
		1884,
		1,
		884
	],
	"./posts.markdown/Post9Elgranretoderr.hh.md": [
		8494,
		1,
		494
	],
	"./posts.markdown/assets/Post10IMG1.png": [
		5564,
		1
	],
	"./posts.markdown/assets/Post11IMG1.png": [
		2311,
		1
	],
	"./posts.markdown/assets/Post12IMG1.png": [
		2435,
		1
	],
	"./posts.markdown/assets/Post1IMG1.jpg": [
		9135,
		1
	],
	"./posts.markdown/assets/Post2IMG1.png": [
		4672,
		1
	],
	"./posts.markdown/assets/Post3IMG1.png": [
		9308,
		1
	],
	"./posts.markdown/assets/Post4IMG1.png": [
		1204,
		1
	],
	"./posts.markdown/assets/Post5IMG1.png": [
		9771,
		1
	],
	"./posts.markdown/assets/Post6IMG1.png": [
		953,
		1
	],
	"./posts.markdown/assets/Post7IMG1.png": [
		273,
		1
	],
	"./posts.markdown/assets/Post8IMG1.png": [
		8882,
		1
	],
	"./posts.markdown/assets/Post9IMG1.png": [
		6738,
		1
	],
	"./posts.markdown/assets/img 04.png": [
		2645,
		1
	],
	"./posts.markdown/assets/img 05.png": [
		5936,
		1
	],
	"./posts.markdown/assets/img 06.png": [
		3056,
		1
	],
	"./posts.markdown/assets/img 10.png": [
		1651,
		1
	],
	"./posts.markdown/assets/img 11.png": [
		795,
		1
	],
	"./posts.markdown/assets/img 12.png": [
		1579,
		1
	],
	"./posts.markdown/assets/img1.png": [
		3150,
		1
	],
	"./posts.markdown/assets/img2.png": [
		4068,
		1
	],
	"./posts.markdown/assets/img3.png": [
		3925,
		1
	],
	"./posts.markdown/assets/img4.png": [
		3501,
		1
	],
	"./posts.markdown/assets/logo_white 2.png": [
		3375,
		1
	],
	"./posts.markdown/assets/overlay.png": [
		8847,
		1
	],
	"./posts.markdown/assets/overlay2.png": [
		897,
		1
	],
	"./posts.markdown/dataPosts": [
		9779,
		9
	],
	"./posts.markdown/dataPosts.js": [
		9779,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4690;
module.exports = webpackAsyncContext;